import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { downloadBlob } from '@/lib/downloadBlob'

interface CsvExportVariables {
  fetchCsv: () => Promise<{ blob: Blob; fileName: string }>
  count: number
}

export function useCsvExport(entityLabel: string) {
  return useMutation({
    mutationFn: ({ fetchCsv }: CsvExportVariables) => fetchCsv(),
    onSuccess: ({ blob, fileName }, { count }) => {
      downloadBlob(blob, fileName)
      toast.success(`Successfully exported ${count} ${count === 1 ? 'item' : 'items'}.`)
    },
    onError: () => {
      toast.error(`Failed to export ${entityLabel}`)
    },
  })
}
